import { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';

import { useUser } from '@clerk/react';

import { extractUtmSearch } from '../utils/analytics/extractUtmSearch';
import { sendGA4PageView } from '../utils/analytics/ga4';

export const useGA4Initialization = () => {
  const { user, isLoaded } = useUser();
  const hasSetUserId = useRef(false);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (hasSetUserId.current) {
      return;
    }

    if (user) {
      ReactGA.set({ user_id: user.id });

      ReactGA.set({
        user_properties: {
          id: user.id,
          email: user.emailAddresses[0]?.emailAddress,
          firstName: user.firstName,
          lastName: user.lastName,
        },
      });

      hasSetUserId.current = true;

      const utmSearch = extractUtmSearch(window.location.search);
      const page = utmSearch
        ? `${window.location.pathname}?${utmSearch}`
        : window.location.pathname;
      sendGA4PageView({ hitType: 'pageview', page });
    }
  }, [isLoaded, user]);
};
